import { motion } from "framer-motion";
import { Users, Package, SealCheck } from "@phosphor-icons/react";
import { Logo } from "@/components/Logo";

const STATS = [
  { icon: Users, big: "Familiar", small: "Negocio de familia" },
  { icon: Package, big: "+100", small: "Pedidos enviados" },
  { icon: SealCheck, big: "1 año", small: "De garantía en todo" },
];

export const Manifesto = () => {
  return (
    <section
      id="nosotros"
      data-testid="manifesto-section"
      className="py-28 lg:py-36 border-t border-black/10 bg-[#F4F5F6]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="relative"
        >
          <img
            src="https://images.unsplash.com/photo-1504280390367-361c6d9f38f4?auto=format&fit=crop&w=1400&q=80"
            alt="Camping bajo las estrellas"
            loading="lazy"
            className="w-full aspect-[4/5] object-cover rounded-2xl"
          />
          <div className="absolute bottom-5 left-5 bg-white rounded-full pl-1.5 pr-5 py-1.5 flex items-center gap-2.5 shadow-lg">
            <Logo alt="" className="h-8 w-8 rounded-full object-cover" />
            <span className="text-xs font-semibold text-[#111418]">Negocio familiar | Xalapa, Veracruz</span>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, delay: 0.15 }}
        >
          <p className="text-[#FF5508] font-semibold text-sm mb-3">Nosotros</p>
          <h2 className="font-semibold text-4xl sm:text-5xl tracking-tight text-[#111418] leading-tight mb-6">
            Una familia que decidió cambiar de ruta
          </h2>
          <p className="text-black/60 text-base leading-relaxed mb-10">
            Ruta 360 nació de las ganas de darle un giro completo a nuestra vida. Fuimos deportistas a nivel nacional
            y nos sigue gustando lo mismo: la naturaleza, acampar y movernos. Por eso vendemos el equipo que nosotros
            mismos usamos, y te atendemos como nos gustaría que nos atendieran.
          </p>

          <div className="grid grid-cols-3 gap-6 mb-10">
            {STATS.map((s) => {
              const Icon = s.icon;
              return (
                <div key={s.big}>
                  <Icon size={24} weight="regular" className="text-[#FF5508] mb-2" />
                  <p className="font-semibold text-2xl lg:text-3xl text-[#111418]">{s.big}</p>
                  <p className="text-black/50 text-xs mt-1">{s.small}</p>
                </div>
              );
            })}
          </div>

          <p className="border-l-4 border-[#FF5508] pl-5 italic text-black/70 text-lg leading-relaxed">
            “Toda gran ruta, por más vueltas que dé, te termina llevando al mismo punto.”
          </p>
        </motion.div>
      </div>
    </section>
  );
};
